import { GroupContractItemDto } from "api/contract";
import { Sizes } from "enums/sizes";
import { NsKey } from "enums/NsKey";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";
import { useDialog } from "hooks/useDialog";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { GenericGroupContractsTable } from "./GenericGroupContractTable";
import { NewGroupContractTypeModal } from "../group-contract-process/components/NewGroupContractTypeModal";
import { GroupContractStepIdentifier } from "../group-contract-process/types/enums";
import { buildProcessRoute } from "../group-contract-process/utils/getRouteByStep";

// Code stable du référentiel StatutsContrats (aligné sur Codes.StatutsContrats côté back).
const STATUT_BROUILLON_CODE = "B";

export default function GroupContractTable() {
  const { t } = useDynamicTranslation([NsKey.Contract, NsKey.Common]);
  const { openBlankDialog, closeDialog } = useDialog();
  const navigate = useNavigate();

  // Modal blank centrée — même UX que l'espace broker.
  const openCreateModal = useCallback(() => {
    openBlankDialog(
      { size: Sizes['5xl'] },
      <NewGroupContractTypeModal onClose={closeDialog} mode="admin" />,
    );
  }, [openBlankDialog, closeDialog]);

  const handleViewGroupContract = useCallback((groupContract: GroupContractItemDto) => {
    if (groupContract.statusCode === STATUT_BROUILLON_CODE) {
      navigate(buildProcessRoute(groupContract.id, GroupContractStepIdentifier.Subscriber));
      return;
    }
    navigate(`/back-office/contrats-groupe/${groupContract.id}`);
  }, [navigate]);

  return (
    <GenericGroupContractsTable
      onViewClick={handleViewGroupContract}
      onCreateConfig={{
        label: t("GROUP_CONTRACT_PROCESS.NEW_CONTRACT_MODAL.BUTTON_LABEL"),
        onClick: openCreateModal,
      }}
    />
  );
}
